import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Our Work',
    href: '#portfolio'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-sm shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <div className="flex justify-between items-center h-16" data-id="element-131">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-132">
            <a href="#" className="block" data-id="element-133">
              <img src="https://cdn.magicpatterns.com/uploads/pNNk2ceH6mKBZ3qz1gUZLh/Sunrise-door-logo.png" alt="Sunrise Door n Trim" className="h-20 md:h-24 w-auto" data-id="element-134" />
            </a>
          </div>

          {/* Desktop Nav - pushed right to sit next to CTA */}
          <div className="hidden md:flex items-center space-x-8 ml-auto mr-8" data-id="element-135">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-sunrise-orange ${scrolled ? 'text-sunrise-charcoal' : 'text-sunrise-charcoal md:text-white md:hover:text-sunrise-orange-light'}`} data-id="element-136">
                {link.name}
              </a>)}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-137">
            <a href="tel:6026326929" className={`flex items-center font-medium ${scrolled ? 'text-sunrise-brown' : 'text-white'}`} data-id="element-138">
              <Phone className="w-4 h-4 mr-2" data-id="element-139" />
              602-632-6929
            </a>
            <Button variant="primary" size="sm" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-140">
              Get a Free Estimate
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-141">
            <button onClick={() => setIsOpen(!isOpen)} className={`p-2 rounded-md ${scrolled ? 'text-sunrise-charcoal' : 'text-white'}`} data-id="element-142">
              {isOpen ? <X className="h-6 w-6" data-id="element-143" /> : <Menu className="h-6 w-6" data-id="element-144" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-white shadow-xl border-t border-gray-100 absolute w-full" data-id="element-145">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-146">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-sunrise-charcoal hover:text-sunrise-orange hover:bg-sunrise-cream rounded-md" onClick={() => setIsOpen(false)} data-id="element-147">
                {link.name}
              </a>)}
            <div className="pt-4 border-t border-gray-100 mt-4" data-id="element-148">
              <a href="tel:6026326929" className="flex items-center justify-center w-full px-4 py-3 text-sunrise-brown font-bold mb-3" data-id="element-149">
                <Phone className="w-5 h-5 mr-2" data-id="element-150" />
                602-632-6929
              </a>
              <Button fullWidth onClick={() => {
            setIsOpen(false);
            document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-151">
                Get a Free Estimate
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}